import { Add, ArrowBack, Delete } from '@mui/icons-material';
import { Fab, IconButton, Tooltip, Typography } from '@mui/material';
import { HomeAppBar, InfiniteTable } from '@prismamedia/one-components';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { SegmentOrderingInput } from '../../../__generated__/queries-web';
import { BrandSwitch } from '../../../components/BrandSwitch';
import { replaceParams } from '../../../routing/Router';
import { paths } from '../../../routing/Router/paths';
import { auth } from '../../../utils/auth';
import { useGlobalBrandKey } from '../../../utils/globalState';
import { useQueryParams } from '../../../utils/useQueryParams';
import { useUpdateSegment } from '../segmentEdit/updateSegment.web.graphql';
import { useSegments } from './getSegments.web.graphql';
import { useStyles } from './styles';

export const SegmentListPage: FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const [brandKey, setBrandKey] = useGlobalBrandKey();
  const updateItem = useUpdateSegment('Le segment a été supprimé !');
  useQueryParams(true);

  const { data, loading, error } = useSegments({
    first: 1000,
    where: { brandKey },
    orderBy: [SegmentOrderingInput.title_ASC],
  });

  return (
    <>
      <HomeAppBar
        appDrawerMenu={
          <IconButton
            className={classes.backIcon}
            onClick={() => history.push(paths.CRUD)}
            size="large"
          >
            <ArrowBack />
          </IconButton>
        }
        brandMenu={
          <>
            <Typography className={classes.title} variant="h6">
              Segments
            </Typography>
            <BrandSwitch brandKey={brandKey} setBrandKey={setBrandKey} />
          </>
        }
        currentUser={auth.user}
        disconnectUser={auth.logout}
      />
      <div className={classes.listWrapper}>
        <InfiniteTable
          list={data?.segments?.filter(({ active }) => active !== false)}
          loading={loading || !brandKey}
          error={error}
          columns={[
            {
              label: 'Titre',
              key: 'title',
              width: 200,
              flexGrow: 1,
            },
            {
              label: 'Marque',
              key: 'brandKey',
              width: 140,
            },
            {
              label: 'Statut',
              key: 'status',
              width: 140,
            },
          ]}
          onRowClick={(e, category) => {
            e.preventDefault();
            history.push(
              replaceParams(paths.SEGMENT_EDIT, {
                id: category.id,
              }),
            );
          }}
          rowHoverRenderer={(category) => (
            <Fab
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                updateItem(category.id, {
                  active: false,
                });
              }}
            >
              <Delete color="primary" />
            </Fab>
          )}
        />
      </div>
      {brandKey && (
        <Tooltip title={`Créer un segment ${brandKey}`}>
          <Fab
            className={classes.newButton}
            color="primary"
            onClick={() => {
              history.push(replaceParams(paths.SEGMENT_NEW, { brandKey }));
            }}
          >
            <Add />
          </Fab>
        </Tooltip>
      )}
    </>
  );
};
